// Any character not allowed in a registration plate (keeps A-Z, 0-9, space, hyphen).
// Case-insensitive so lowercase input survives for the caller to upper-case.
const DISALLOWED_PLATE_CHAR_REGEX = /[^A-Z0-9 -]/gi;

/** Removes every character not permitted in a registration plate, without changing case. */
export const stripDisallowedPlateChars = (value: string) =>
  value.replace(DISALLOWED_PLATE_CHAR_REGEX, '');
